<template>
  <Layout>
    <div class="headerOfReport"></div>
    Wybierz parametry raportu:
    <br>
      Poziom graniczny
            <input
              type="number"
              min="0"
              max="100"
              class="right narrow marright"
              v-model="thresholdLevelPercent"
            />%
    <mdb-form-inline>
      <mdb-input type="checkbox" v-model="cbx1" label="Pilne" />
      <mdb-input type="checkbox" v-model="cbx2" label="Na wyczerpaniu w lok. Półka" />
      <mdb-input type="checkbox" v-model="cbx3" label="Na wyczerpaniu w lok. Podręczny" />
      <mdb-input type="checkbox" v-model="cbx4" label="Kończące się" />
      <mdb-input type="checkbox" v-model="cbx5" label="Wyłączone" />
      <mdb-input type="checkbox" v-model="cbx6" label="Niedostępne" />
    </mdb-form-inline>

    <mdb-btn gradient="purple" @click="mthCreateReport()">Utwórz Raport</mdb-btn>
    <mdb-btn gradient="purple" @click="mthServeReportAsPdf()">PDF</mdb-btn>

    
      <h2>Raport produktów z dnia {{new Date().toLocaleString()}}</h2>

      <table id="reportContent" width="100%" class="report">
        <!-- header -->
        <thead>
        <tr>
          <th>Lp</th>
          <th>Nr kat.</th>
          <th>Nazwa</th>
          <th>Polka</th>
          <th>Podreczny</th>
          <th>Palety</th>
          <th>Stan ISZ</th>
        </tr>
        </thead>

        <tbody>
        <tr v-for="(p,index) in reportdata" :key="'k'+index">
          <td>{{index+1}}</td>
          <td>{{p.nr_kat}}</td>
          <td>{{p.nazwa}}</td>
          <td class="right">{{p.swmApolka}}</td>
          <td class="right">{{p.swmBpodreczny}}</td>
          <td class="right">{{p.swmCpalety}}</td>
          <td class="right">{{p.stan_cache}}</td>
        </tr>
        </tbody>
        
      </table>
    
  </Layout>
</template>

<script>
import { mdbIcon } from "mdbvue";
import { mdbBtn } from "mdbvue";
import { mdbInput } from "mdbvue";
import { mdbFormInline } from "mdbvue";
import jsPDF from 'jspdf';
import 'jspdf-autotable';

export default {
  name: "report",
  data() {
    return {
      thresholdLevelPercent: 10,
      reportdata: [],
      cbx1: false,
      cbx2: false,
      cbx3: false,
      cbx4: false,
      cbx5: false,
      cbx6: false
    };
  },
  created() {},
  methods: {
    mthServeReportAsPdf() {
      
      var doc = new jsPDF('p', 'pt');
      

      //doc.addFont("arial.ttf", "Arial", "normal");
      //doc.addFont("Arimo-Bold.ttf", "Arimo", "bold");
      //doc.setFont("Helvetica");
      //doc.setFontSize(6);
      //doc.setFontType("normal");

      //doc.addFileToVFS(Arial)
      // doc.addFont('Arial', 'normal');
      //doc.setFont('Arial');

      //var elem = document.getElementById("reportContent");

      //var res = doc.autoTableHtmlToJson(elem);
      //doc.autoTable(res.columns, res.data);

      doc.autoTable(
        {
          html: '#reportContent',
          styles:{fontSize: 3, font: "courier", cellWidth: 'auto', cellPadding: 1}
        
        },

        
        );

      // doc.fromHTML(document.getElementById("reportContent"), 15, 15, {
      //   width: 1000
      // });

      doc.save("report.pdf");
    },
    mthGetDataForReport() {
      var apiurl =
        this.$config.API_URL +
        "/productsreport?c1=" +
        this.cbx1 +
        "&c2=" +
        this.cbx2 +
        "&c3=" +
        this.cbx3 +
        "&c4=" +
        this.cbx4 +
        "&c5=" +
        this.cbx5 +
        "&c6=" +
        this.cbx6 +
        "&thr=" +
        this.thresholdLevelPercent +
        "";

      console.log("apiurl: ");
      console.log(apiurl);

      var that = this;

      this.$axios({
        method: "get",
        url: apiurl
      })
        .then(function(response) {
          //console.log("products:");
          //console.log(response.data);
          that.reportdata = response.data;
          //console.log(item)
          //console.log(that.reportdata);
          //that.refresher++;
        })
        .catch(function(error) {
          console.log(error);
          //that.msg = "Brak połączenia z API (" + error + ").";
        });
    },
    mthCreateReport() {
      console.log("will create report");

      this.mthGetDataForReport();

      
    }
  },
  components: {
    mdbBtn,
    mdbIcon,
    mdbInput,
    mdbFormInline
  }
};
</script>

<style scoped>
.header {
  background-color: grey;
}
.right{text-align: right; }
.narrow{width: 60px;}
.marright {margin-right: 15px;margin-left: 5px;}

#reportContent, #reportContent td, #reportContent th{
  font-family: Courier !important;
  font-size:12pt;
  border-collapse: collapse; 
  border: 1px solid black
}
</style>
